import { ref, watch } from "vue";
import bus from "@/lib/bus";
import ProgressBar from "@/components/ProgressBar/ProgressBar.vue";
export default {
  components: {
    ProgressBar
  },
  props: ["type", "detailList"],
  setup(props, context) {
    const setWidth = ref(window.innerWidth > 390 ? 120 : 100);
    const list = ref([]);
    const choiceBlock = ref(0); // 选中的商品
    const nowType = props;
    watch(nowType, newValue => {
      if (newValue) {
        list.value = newValue.detailList;
      }
    }, {
      deep: true
    });

    // 点击商品
    const choiceItem = e => {
      choiceBlock.value = e.id;
      context.emit("choiceProduct", e);
    };
    bus.$on("clearProductList", () => {
      choiceBlock.value = 0;
    });
    const isMobile = () => {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    return {
      isMobile,
      choiceItem,
      choiceBlock,
      nowType,
      list,
      setWidth
    };
  }
};